import { Component, Signal, computed, input } from '@angular/core';
import { BaseComponent } from '@shared-components/base-component';
import { AppHelper } from '@shared-helpers/appHelper';
import { ProductHelper } from '@shared-helpers/productHelper';
import { ExpertModel } from '@shared-model/expert/ExpertModel';
import { ProductModel } from '@shared-model/products/ProductModel';

@Component({
  selector: 'fourd-create-account',
  templateUrl: './create-account.component.html',
  providers: [...BaseComponent.componentProviders],
})
export class CreateAccountComponent extends BaseComponent {
  readonly expert = input<ExpertModel>(undefined);
  readonly productTypeIds = input<number[]>(undefined);

  bestOfferProduct: Signal<ProductModel> = computed(() => this.memberService?.getBestProduct(this.productTypeIds(), this.expert()?.ExpertTariffTypeId), { equal: AppHelper.objectsEqual });

  constructor() { super("CreateAccountComponent"); }

  isProductBundleSession(product: ProductModel): boolean {
    return ProductHelper.isProductTypeBundleSession(product?.ProductTypeId);
  }

  isProductPaygSession(product: ProductModel): boolean {
    return ProductHelper.isProductTypePaygSession(product?.ProductTypeId);
  }

  isProductGeneralTopUp(product: ProductModel): boolean {
    return ProductHelper.isProductTypeGeneralTopUp(product?.ProductTypeId);
  }

  isProductMinutesTopUp(product: ProductModel): boolean {
    return ProductHelper.isProductTypeMinutesTopUp(product?.ProductTypeId);
  }

  showSimplifiedOffer(offerProduct: ProductModel): boolean {
    return ProductHelper.isOfferLoyalty(offerProduct?.OfferId) || ProductHelper.isOfferIntroductory(offerProduct?.OfferId);
  }
}
